
  <!--
 * 竖版
 * @LastEditTime: Tue Dec 17 2024 15:43:03 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_JWX421" :class="[curLang]" class="u_r_JWX421 route-m"  ><div id="u_c_JINJ24"  :class="[`normal background-color`,`u_c_JINJ24`]" ><u_c_26FL21></u_c_26FL21><u_c_0MJ127></u_c_0MJ127><u_c_QXLF22></u_c_QXLF22><u_c_6XIJ23></u_c_6XIJ23><u_c_XTM149></u_c_XTM149><u_c_DIDC46></u_c_DIDC46><u_c_6FRM32></u_c_6FRM32><u_c_UGFG27></u_c_UGFG27><u_c_TXC195></u_c_TXC195></div><u_c_EEKH149></u_c_EEKH149><div id="u_c_QYZ7409"  :class="[`normal`,`u_c_QYZ7409`]" ></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_26FL21 from "@/components/u_c_26FL21.vue";import u_c_0MJ127 from "@/components/u_c_0MJ127.vue";import u_c_QXLF22 from "@/components/u_c_QXLF22.vue";import u_c_XTM149 from "@/components/u_c_XTM149.vue";import u_c_DIDC46 from "@/components/u_c_DIDC46.vue";import u_c_6FRM32 from "@/components/u_c_6FRM32.vue";import u_c_TXC195 from "@/components/u_c_TXC195.vue";import u_c_EEKH149 from "@/components/u_c_EEKH149.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});

if (window.innerWidth > window.innerHeight && router.hasRoute('index')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/');
  }
} else {
  init();
}

    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.zh-CN ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.zh-CN ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.zh-CN ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.zh-CN ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.zh-CN ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.zh-CN ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.zh-CN ::v-deep(.normal .popup-title-color){
color:#131210;

}

.zh-CN ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.zh-CN ::v-deep(.normal .txt-color){
color:#131210;

}

.zh-CN ::v-deep(.normal .tips-color){
color:red;

}

.zh-CN ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.zh-CN ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.zh-CN ::v-deep(.background-color){
background:#1b2c3c;

}

.zh-CN ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.zh-CN ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.zh-TW ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.zh-TW ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.zh-TW ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.zh-TW ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.zh-TW ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.zh-TW ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.zh-TW ::v-deep(.normal .popup-title-color){
color:#131210;

}

.zh-TW ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.zh-TW ::v-deep(.normal .txt-color){
color:#131210;

}

.zh-TW ::v-deep(.normal .tips-color){
color:red;

}

.zh-TW ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.zh-TW ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.zh-TW ::v-deep(.background-color){
background:#1b2c3c;

}

.zh-TW ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.zh-TW ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.en-US ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.en-US ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.en-US ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.en-US ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.en-US ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.en-US ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.en-US ::v-deep(.normal .popup-title-color){
color:#131210;

}

.en-US ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.en-US ::v-deep(.normal .txt-color){
color:#131210;

}

.en-US ::v-deep(.normal .tips-color){
color:red;

}

.en-US ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.en-US ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.en-US ::v-deep(.background-color){
background:#1b2c3c;

}

.en-US ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.en-US ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.ja-JP ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.ja-JP ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.ja-JP ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.ja-JP ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.ja-JP ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.ja-JP ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.ja-JP ::v-deep(.normal .popup-title-color){
color:#131210;

}

.ja-JP ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.ja-JP ::v-deep(.normal .txt-color){
color:#131210;

}

.ja-JP ::v-deep(.normal .tips-color){
color:red;

}

.ja-JP ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.ja-JP ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.ja-JP ::v-deep(.background-color){
background:#1b2c3c;

}

.ja-JP ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.ja-JP ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.ko-KR ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.ko-KR ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.ko-KR ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.ko-KR ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.ko-KR ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.ko-KR ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.ko-KR ::v-deep(.normal .popup-title-color){
color:#131210;

}

.ko-KR ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.ko-KR ::v-deep(.normal .txt-color){
color:#131210;

}

.ko-KR ::v-deep(.normal .tips-color){
color:red;

}

.ko-KR ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.ko-KR ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.ko-KR ::v-deep(.background-color){
background:#1b2c3c;

}

.ko-KR ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.ko-KR ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.th-TH ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.th-TH ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.th-TH ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.th-TH ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.th-TH ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.th-TH ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.th-TH ::v-deep(.normal .popup-title-color){
color:#131210;

}

.th-TH ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.th-TH ::v-deep(.normal .txt-color){
color:#131210;

}

.th-TH ::v-deep(.normal .tips-color){
color:red;

}

.th-TH ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.th-TH ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.th-TH ::v-deep(.background-color){
background:#1b2c3c;

}

.th-TH ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.th-TH ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.vi-VN ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.vi-VN ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.vi-VN ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.vi-VN ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.vi-VN ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.vi-VN ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.vi-VN ::v-deep(.normal .popup-title-color){
color:#131210;

}

.vi-VN ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.vi-VN ::v-deep(.normal .txt-color){
color:#131210;

}

.vi-VN ::v-deep(.normal .tips-color){
color:red;

}

.vi-VN ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.vi-VN ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.vi-VN ::v-deep(.background-color){
background:#1b2c3c;

}

.vi-VN ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.vi-VN ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.de-DE ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.de-DE ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.de-DE ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.de-DE ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.de-DE ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.de-DE ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.de-DE ::v-deep(.normal .popup-title-color){
color:#131210;

}

.de-DE ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.de-DE ::v-deep(.normal .txt-color){
color:#131210;

}

.de-DE ::v-deep(.normal .tips-color){
color:red;

}

.de-DE ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.de-DE ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.de-DE ::v-deep(.background-color){
background:#1b2c3c;

}

.de-DE ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.de-DE ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.fr-FR ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.fr-FR ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.fr-FR ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.fr-FR ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.fr-FR ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.fr-FR ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.fr-FR ::v-deep(.normal .popup-title-color){
color:#131210;

}

.fr-FR ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.fr-FR ::v-deep(.normal .txt-color){
color:#131210;

}

.fr-FR ::v-deep(.normal .tips-color){
color:red;

}

.fr-FR ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.fr-FR ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.fr-FR ::v-deep(.background-color){
background:#1b2c3c;

}

.fr-FR ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.fr-FR ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.ru-RU ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.ru-RU ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.ru-RU ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.ru-RU ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.ru-RU ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.ru-RU ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.ru-RU ::v-deep(.normal .popup-title-color){
color:#131210;

}

.ru-RU ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.ru-RU ::v-deep(.normal .txt-color){
color:#131210;

}

.ru-RU ::v-deep(.normal .tips-color){
color:red;

}

.ru-RU ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.ru-RU ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.ru-RU ::v-deep(.background-color){
background:#1b2c3c;

}

.ru-RU ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.ru-RU ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.es-ES ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.es-ES ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.es-ES ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.es-ES ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.es-ES ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.es-ES ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.es-ES ::v-deep(.normal .popup-title-color){
color:#131210;

}

.es-ES ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.es-ES ::v-deep(.normal .txt-color){
color:#131210;

}

.es-ES ::v-deep(.normal .tips-color){
color:red;

}

.es-ES ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.es-ES ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.es-ES ::v-deep(.background-color){
background:#1b2c3c;

}

.es-ES ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.es-ES ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.pt-PT ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.pt-PT ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.pt-PT ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.pt-PT ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.pt-PT ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.pt-PT ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.pt-PT ::v-deep(.normal .popup-title-color){
color:#131210;

}

.pt-PT ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.pt-PT ::v-deep(.normal .txt-color){
color:#131210;

}

.pt-PT ::v-deep(.normal .tips-color){
color:red;

}

.pt-PT ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.pt-PT ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.pt-PT ::v-deep(.background-color){
background:#1b2c3c;

}

.pt-PT ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.pt-PT ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.it-IT ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.it-IT ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.it-IT ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.it-IT ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.it-IT ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.it-IT ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.it-IT ::v-deep(.normal .popup-title-color){
color:#131210;

}

.it-IT ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.it-IT ::v-deep(.normal .txt-color){
color:#131210;

}

.it-IT ::v-deep(.normal .tips-color){
color:red;

}

.it-IT ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.it-IT ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.it-IT ::v-deep(.background-color){
background:#1b2c3c;

}

.it-IT ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.it-IT ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.tr-TR ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.tr-TR ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.tr-TR ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.tr-TR ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.tr-TR ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.tr-TR ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.tr-TR ::v-deep(.normal .popup-title-color){
color:#131210;

}

.tr-TR ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.tr-TR ::v-deep(.normal .txt-color){
color:#131210;

}

.tr-TR ::v-deep(.normal .tips-color){
color:red;

}

.tr-TR ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.tr-TR ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.tr-TR ::v-deep(.background-color){
background:#1b2c3c;

}

.tr-TR ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.tr-TR ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.pl-PL ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.pl-PL ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.pl-PL ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.pl-PL ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.pl-PL ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.pl-PL ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.pl-PL ::v-deep(.normal .popup-title-color){
color:#131210;

}

.pl-PL ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.pl-PL ::v-deep(.normal .txt-color){
color:#131210;

}

.pl-PL ::v-deep(.normal .tips-color){
color:red;

}

.pl-PL ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.pl-PL ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.pl-PL ::v-deep(.background-color){
background:#1b2c3c;

}

.pl-PL ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.pl-PL ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.id-ID ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.id-ID ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.id-ID ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.id-ID ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.id-ID ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.id-ID ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.id-ID ::v-deep(.normal .popup-title-color){
color:#131210;

}

.id-ID ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.id-ID ::v-deep(.normal .txt-color){
color:#131210;

}

.id-ID ::v-deep(.normal .tips-color){
color:red;

}

.id-ID ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.id-ID ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.id-ID ::v-deep(.background-color){
background:#1b2c3c;

}

.id-ID ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.id-ID ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.ar-SA ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.ar-SA ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.ar-SA ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.ar-SA ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.ar-SA ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.ar-SA ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.ar-SA ::v-deep(.normal .popup-title-color){
color:#131210;

}

.ar-SA ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.ar-SA ::v-deep(.normal .txt-color){
color:#131210;

}

.ar-SA ::v-deep(.normal .tips-color){
color:red;

}

.ar-SA ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.ar-SA ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.ar-SA ::v-deep(.background-color){
background:#1b2c3c;

}

.ar-SA ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.ar-SA ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.default ::v-deep(.normal .popup){
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.default ::v-deep(.normal .popup-content-small){
width:9.64rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134384532183203.png);
position:relative;
box-sizing:border-box;
padding:0.80rem 1.07rem;

}

.default ::v-deep(.normal .popup-close){
width:0.53rem;
height:0.53rem;
background:no-repeat center;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/11/170134392096828063.png);
background-size:contain;

}

.default ::v-deep(.normal .popup-title){
font-size:0.43rem;
text-align:center;

}

.default ::v-deep(.normal .popup-content-big){
width:9.23rem;
height:auto;
background:no-repeat center;
background-size:100% 100%;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170261213983686860.png);
position:relative;
padding:0.53rem 0.67rem;
max-width:95vw;
min-height:4.00rem;

}

.default ::v-deep(.normal .sure){
display:flex;
width:3.53rem;
height:1.39rem;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/04/1712731697416-4.png);
font-size:0.32rem;
color:#fff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.default ::v-deep(.normal .popup-title-color){
color:#131210;

}

.default ::v-deep(.normal .txt-size){
font-size:0.35rem;

}

.default ::v-deep(.normal .txt-color){
color:#131210;

}

.default ::v-deep(.normal .tips-color){
color:red;

}

.default ::v-deep(.normal .border-color){
border:1px solid;
border-color:#ffffff;

}

.default ::v-deep(.normal .invite-input){
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto;
padding:0 0.27rem;

}

.default ::v-deep(.background-color){
background:#1b2c3c;

}

.default ::v-deep(.normal .main-color){
color:#dbdbdb;

}

.default ::v-deep(.normal .highlight){
color:#ffdd7b;
font-weight:bold;

}
#sharePopup .share-main-list {
  margin-top: 0 !important
}
#sharePopup .share-main-btn {
  padding-top: 10px !important;
}

body,
html {
  height: unset !important
}

#u_r_JWX421,#u_r_MEHF16 {
  display: flex;
  flex-direction: column;
}
.u_c_JINJ24.normal{
position:relative;
width:10.00rem;
height:auto;
margin:0 auto;
min-height:100vh;
padding-bottom:1.33rem;

}

.u_c_QYZ7409.normal{
position:relative;

}

</style>
